export default "__VITE_ASSET__Ckt2t_B5__"